export default __webpack_public_path__ + "static/media/logo_pole_emploi.f34e9a2c.jpg";